import constants from '@/constants.js';

class ProjectServiceHelper {
    getStateStyle (state) {
        switch (state) {
        case constants.PROJECT_STATE.DRAFT:
            return 'is-success';
        case constants.PROJECT_STATE.PUBLISHED:
            return 'is-info';
        case constants.PROJECT_STATE.ARCHIVED:
            return 'is-danger';
        case constants.PROJECT_STATE.PUBLISHING:
            return 'is-warning';
        default:
            return '';
        }
    }
}

export const projectServiceHelper = new ProjectServiceHelper();
